import { createSelector } from 'reselect';

export const selectStatusesLoading = createSelector(
  (state) => state.getIn(['statuses', 'loading']),
  (loading) => loading,
);

export const selectStatuses = createSelector(
  (state) => state.getIn(['statuses', 'data']),
  (data) => data.toJS(),
);
